import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type Search = {
  start: number;
  end: number;
  nama : string | number |null;
  kodemenu: string | null;
  tahun: string | null;
  nomorPeraturan: string | null;
};

const initialState: Search = {
  start: 1,
  end: 10,
  kodemenu: null,
  tahun: null,
  nama: null,
  nomorPeraturan: null,
};

export const paginateBumn = createSlice({
  name: 'paginateBumn',
  initialState,
  reducers: {
    replaceAllPaginate: (state, action: PayloadAction<Search>) => {
      // Use the action.payload to update the state
      state.start = action.payload.start;
      state.end = action.payload.end;
      state.kodemenu = action.payload.kodemenu;
      state.tahun = action.payload.tahun;
      state.nomorPeraturan = action.payload.nomorPeraturan;
      state.nama = action.payload.nama;
    },
  },
});

export const { replaceAllPaginate } = paginateBumn.actions;
export default paginateBumn.reducer;
